// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import Instagram from "@mui/icons-material/Instagram";
import LinkedIn from "@mui/icons-material/LinkedIn";
import MKTypography from "components/MKTypography";

// Images
// import logoCT from "assets/images/logo-ct-dark.png";
import techVescosityLogo from "assets/images/logos/techVescosityLogo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Virtua Staging",
    image: techVescosityLogo,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/vescositycom/",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/vescositycom",
    },
    {
      icon: <Instagram />,
      link: "https://www.instagram.com/vescositycom/",
    },
    {
      icon: <LinkedIn />,
      link: "https://linkedin.com/company/vescosity",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "about us", href: "https://vescosity.com/about" },
        // { name: "freebies", href: "https://vescosity.com/templates/free" },
        // { name: "premium tools", href: "https://vescosity.com/templates/premium" },
        { name: "blog", href: "https://vescosity.com/blog" },
      ],
    },
    {
      name: "help & support",
      items: [
        { name: "contact us", href: "https://vescosity.com/contact-us" },
        // { name: "knowledge center", href: "https://vescosity.com/knowledge-center" },
        // { name: "sponsorships", href: "https://vescosity.com/sponsorships" },
      ],
    },
    {
      name: "legal",
      items: [
        { name: "terms & conditions", href: "https://vescosity.com/terms" },
        { name: "privacy policy", href: "https://vescosity.com/privacy" },
        { name: "licenses (EULA)", href: "https://vescosity.com/terms-and-conditions" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} by
      <MKTypography
        component="a"
        href="https://vescosity.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Tech Vescosity
      </MKTypography>
      .
    </MKTypography>
  ),
};
